"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopBar = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const common_1 = require("@/components/common");
const top_bar_styles_1 = require("@/components/layouts/top-bar/top-bar.styles");
const utils_1 = require("@/utils");
require("@/components/common");
let TopBar = class TopBar extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.heading = '';
        this.nav = 'back';
        this.handleNavClick = () => {
            (0, utils_1.emit)(this, 'nav-click');
        };
    }
    render() {
        return (0, lit_1.html) `
      <header>
        ${this.renderBackButton()}
        <mm-heading level="3">${this.heading}</mm-heading>
        <div class="trailing-area">
          <slot name="action"></slot>
          ${this.renderCloseButton()}
        </div>
      </header>
    `;
    }
    renderBackButton() {
        if (this.nav !== 'back')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon-button
        variant="secondary"
        icon=${common_1.ICON_NAMES.BACK}
        aria-label="뒤로"
        @click=${this.handleNavClick}
      ></mm-icon-button>
    `;
    }
    renderCloseButton() {
        if (this.nav !== 'close')
            return lit_1.nothing;
        return (0, lit_1.html) `
      <mm-icon-button
        variant="secondary"
        icon=${common_1.ICON_NAMES.CLOSE}
        aria-label="닫기"
        @click=${this.handleNavClick}
      ></mm-icon-button>
    `;
    }
};
TopBar.styles = [top_bar_styles_1.topBarStyles];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TopBar.prototype, "heading", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], TopBar.prototype, "nav", void 0);
TopBar = __decorate([
    (0, decorators_js_1.customElement)('mm-top-bar')
], TopBar);
exports.TopBar = TopBar;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidG9wLWJhci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbInRvcC1iYXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsNkJBQStDO0FBQy9DLHFEQUEyRDtBQUUzRCxnREFBZ0Q7QUFDaEQsZ0ZBQTBFO0FBQzFFLG1DQUE4QjtBQUM5QiwrQkFBNEI7QUFVckIsSUFBTSxNQUFNLEdBQVosTUFBTSxNQUFPLFNBQVEsZ0JBQVU7SUFBL0I7O1FBRXVCLFlBQU8sR0FBRyxFQUFFLENBQUE7UUFDWixRQUFHLEdBQWMsTUFBTSxDQUFBO1FBeUMzQyxtQkFBYyxHQUFHLEdBQUcsRUFBRTtZQUM1QixJQUFBLFlBQUksRUFBQyxJQUFJLEVBQUUsV0FBVyxDQUFDLENBQUE7UUFDekIsQ0FBQyxDQUFBO0lBQ0gsQ0FBQztJQTFDQyxNQUFNO1FBQ0osT0FBTyxJQUFBLFVBQUksRUFBQTs7VUFFTCxJQUFJLENBQUMsZ0JBQWdCLEVBQUU7Z0NBQ0QsSUFBSSxDQUFDLE9BQU87OztZQUdoQyxJQUFJLENBQUMsaUJBQWlCLEVBQUU7OztLQUcvQixDQUFBO0lBQ0gsQ0FBQztJQUVPLGdCQUFnQjtRQUN0QixJQUFJLElBQUksQ0FBQyxHQUFHLEtBQUssTUFBTTtZQUFFLE9BQU8sYUFBTyxDQUFBO1FBRXZDLE9BQU8sSUFBQSxVQUFJLEVBQUE7OztlQUdBLG1CQUFVLENBQUMsSUFBSTs7aUJBRWIsSUFBSSxDQUFDLGNBQWM7O0tBRS9CLENBQUE7SUFDSCxDQUFDO0lBRU8saUJBQWlCO1FBQ3ZCLElBQUksSUFBSSxDQUFDLEdBQUcsS0FBSyxPQUFPO1lBQUUsT0FBTyxhQUFPLENBQUE7UUFFeEMsT0FBTyxJQUFBLFVBQUksRUFBQTs7O2VBR0EsbUJBQVUsQ0FBQyxLQUFLOztpQkFFZCxJQUFJLENBQUMsY0FBYzs7S0FFL0IsQ0FBQTtJQUNILENBQUM7O0FBekNNLGFBQU0sR0FBRyxDQUFDLDZCQUFZLENBQUMsQ0FBQTtBQUNGO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt1Q0FBYTtBQUNaO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzttQ0FBd0I7QUFIeEMsTUFBTTtJQURsQixJQUFBLDZCQUFhLEVBQUMsWUFBWSxDQUFDO0dBQ2YsTUFBTSxDQStDbEI7QUEvQ1ksd0JBQU0ifQ==